module.exports = __webpack_public_path__ + "static/media/detail_0012_t.89c4022f.jpg";